import { render, staticRenderFns } from "./redirects.page.vue?vue&type=template&id=41ec343a&scoped=true&"
import script from "./redirects.page.vue?vue&type=script&lang=js&"
export * from "./redirects.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ec343a",
  null
  
)

export default component.exports